import React from 'react';
import { Info, Shield } from 'lucide-react';

/**
 * Health Disclaimer Component
 * Displays medical disclaimer and trust badges
 */
export const HealthDisclaimer = ({ variant = 'default', className = '' }) => {
  if (variant === 'compact') {
    return (
      <div className={`flex items-center gap-2 text-xs text-gray-600 ${className}`}>
        <Info className="h-3 w-3 flex-shrink-0" />
        <span>This app provides non-clinical health guidance and does not replace professional medical advice.</span>
      </div>
    );
  }

  if (variant === 'footer') {
    return (
      <div className={`bg-blue-50 border border-blue-200 rounded-lg p-4 ${className}`}>
        <div className="flex items-start gap-3">
          <Shield className="h-5 w-5 text-blue-600 flex-shrink-0 mt-0.5" />
          <div className="text-sm text-blue-900">
            <p className="font-semibold mb-2">Important Health Information</p>
            <p className="mb-2">
              This app provides <strong>non-clinical health guidance</strong> and does not replace professional medical advice, diagnosis, or treatment.
            </p>
            <p className="text-xs text-blue-800">
              Always consult with a qualified healthcare provider for medical concerns or before making changes to your health routine.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Default variant
  return (
    <div className={`bg-gray-50 border border-gray-200 rounded-lg p-3 ${className}`}>
      <div className="flex items-start gap-2">
        <Info className="h-4 w-4 text-gray-600 flex-shrink-0 mt-0.5" />
        <p className="text-xs text-gray-700">
          <strong>Medical Disclaimer:</strong> This app provides general health information and does not replace professional medical advice. Always consult your healthcare provider for medical concerns.
        </p>
      </div>
    </div>
  );
};

/**
 * Evidence Badge Component
 * Shows that recommendations are based on trusted sources
 */
export const EvidenceBadge = ({ className = '' }) => {
  return (
    <div className={`inline-flex items-center gap-1.5 px-2 py-1 bg-green-50 border border-green-200 rounded-full ${className}`}>
      <Shield className="h-3 w-3 text-green-700" />
      <span className="text-xs font-medium text-green-800">
        Based on global public health guidance
      </span>
    </div>
  );
};

/**
 * Source Attribution Component
 * Shows which health organizations inform the recommendations
 */
export const SourceAttribution = ({ sources = ['WHO', 'NHS', 'CDC'], className = '' }) => {
  return (
    <div className={`text-xs text-gray-600 ${className}`}>
      <span className="font-medium">Sources: </span>
      {sources.join(' • ')}
    </div>
  );
};

export default HealthDisclaimer;
